import { render, staticRenderFns } from "./ProgressoPreenchimento.vue?vue&type=template&id=4d5f435d&scoped=true&"
import script from "./ProgressoPreenchimento.vue?vue&type=script&lang=ts&"
export * from "./ProgressoPreenchimento.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressoPreenchimento.vue?vue&type=style&index=0&id=4d5f435d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5f435d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
